export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  // Entra config is only needed for Private forms (respondent sign-in). Empty = disabled.
  entra: {
    tenantId: import.meta.env.VITE_ENTRA_TENANT_ID ?? 'common',
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
    apiScope: import.meta.env.VITE_API_SCOPE ?? '',
  },
};

/**
 * Resolves the form id from the URL: path form `/f/{id}` (hosted page) or `?formId=`
 * (embedding / dev). Returns null if none present.
 */
export function resolveFormId(): string | null {
  const fromQuery = new URLSearchParams(window.location.search).get('formId');
  if (fromQuery) {
    return fromQuery;
  }
  const match = window.location.pathname.match(/\/f\/([0-9a-fA-F-]{36})/);
  return match ? match[1] : null;
}

/** Secret-link access token from the URL (?t=…), required to open a SecretLink form. */
export function resolveAccessToken(): string | null {
  return new URLSearchParams(window.location.search).get('t');
}
